// 懸賞版各列舉值的顯示對應（集中管理，避免各頁面各自硬寫造成不一致）

// 兩大分類：報修 / 任務
export const BOUNTY_TYPES = [
  { value: 'REPAIR', label: '報修' },
  { value: 'TASK', label: '任務' },
];

// 等級：低 / 中 / 高 / L1（單選），與後端 CHECK 一致
export const LEVELS = [
  { value: 'LOW', label: '低' },
  { value: 'MID', label: '中' },
  { value: 'HIGH', label: '高' },
  { value: 'L1', label: 'L1' },
];

// 狀態流轉：開放中 → 進行中 → 待結案 → 已結案（另有已取消）
export const STATUSES = [
  { value: 'OPEN', label: '開放中' },
  { value: 'CLAIMED', label: '進行中' },
  { value: 'SUBMITTED', label: '待結案' },
  { value: 'CLOSED', label: '已結案' },
  { value: 'CANCELLED', label: '已取消' },
];

// 列表排序選項
export const SORTS = [
  { value: 'new', label: '最新發布' },
  { value: 'old', label: '開立時間早到晚' },
  { value: 'deadline', label: '截止期限近到遠' },
  { value: 'level', label: '等級高到低' },
  { value: 'points', label: '點數多到少' },
];

// 折疊分組的等級順序：L1 最緊急，依序往下（報修依此分組與排列）
export const LEVEL_GROUP_ORDER = ['L1', 'HIGH', 'MID', 'LOW'];

const findLabel = (list, v) => (list.find((t) => t.value === v)?.label || v || '-');
export const typeLabel = (v) => findLabel(BOUNTY_TYPES, v);
export const levelLabel = (v) => findLabel(LEVELS, v);
export const statusLabel = (v) => findLabel(STATUSES, v);

// 狀態對應的色票 class 後綴（搭配 Bounty.css 的 .badge-status-*）
export const statusClass = (v) => `badge-status-${String(v || '').toLowerCase()}`;
// 等級對應的色票 class 後綴
export const levelClass = (v) => `badge-level-${String(v || '').toLowerCase()}`;
